import { BaseErrorStatus } from '@app/api/enums/base-error-status.enum';
import { IApiResponseError } from '@app/api/interfaces/common/api-response-error.interface';
import { Nullable } from 'primeng/ts-helpers';
import { IUserMe } from '@app/api/interfaces/user-me.interface';

export const userMeKey = 'userMe';

export interface IUserMeState {
  loaded: boolean;
  loading: boolean;
  data: Nullable<IUserMe>;
  error: IApiResponseError<BaseErrorStatus> | null;
}

export const initialState: IUserMeState = {
  loaded: false,
  loading: false,
  data: null,
  error: null,
};
